import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Pagination, EffectFade, Thumbs } from "swiper/modules";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Sliders {
	constructor() {
		this.sctrigger;
		this.sliders = document.querySelectorAll(".slider");
		if (this.sliders) {
			this.init();
		}
	}

	init() {
		this.sliders.forEach((slider) => {
			const sliderID = slider.id;
			const swiper = slider.querySelector(".swiper-main");
			const thumbs = slider.querySelector(".swiper-thumbs");
			const dataOptions = swiper.dataset.options ?? false;
			const customOptions = JSON.parse(dataOptions);
			const countOfSlides = parseInt(swiper.dataset.count);

			let swiperOptions = {
				centerInsufficientSlides: true,
				modules: [A11y, Navigation, Pagination],
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20,
				loop: true,
				navigation: {
					nextEl: "#" + sliderID + " .swiper-button-next",
					prevEl: "#" + sliderID + " .swiper-button-prev",
				},
				pagination: {
					el: "#" + sliderID + " .swiper-pagination",
					clickable: true,
					dynamicBullets: true,
				},
				breakpointsBase: "container",
				...customOptions,
			};

			if (countOfSlides < 2) {
				swiperOptions.loop = false;
			}

			if (swiperOptions.autoplay) {
				swiperOptions.modules.push(Autoplay);
			}

			if (swiperOptions.effect == "fade") {
				swiperOptions.modules.push(EffectFade);
			}

			if (thumbs) {
				let theThumbs = new Swiper(thumbs, {
					breakpoints: {
						790: { slidesPerView: 5 },
						950: { slidesPerView: 6 },
						1110: { slidesPerView: 7 },
						1270: { slidesPerView: 8 },
					},
					breakpointsBase: "container",
					modules: [A11y, Navigation],
					navigation: {
						nextEl: "#" + sliderID + " .swiper-thumbs-button-next",
						prevEl: "#" + sliderID + " .swiper-thumbs-button-prev",
					},
					slidesPerView: 4,
					spaceBetween: 10,
					watchSlidesProgress: true,
				});

				swiperOptions.modules.push(Thumbs);
				swiperOptions.thumbs = {
					swiper: theThumbs,
				};
			}

			let theSwiper = new Swiper(swiper, swiperOptions);

			console.log("Swiper initialized:", theSwiper);

			const parentElement = slider.parentElement;

			/* if (parentElement.classList.contains("autoplay-trigger")) {
				theSwiper.autoplay.stop();
				parentElement.addEventListener("mouseenter", () => {
					theSwiper.enable();
					setTimeout(() => {
						theSwiper.slideNext();
						theSwiper.autoplay.start();
					}, 500);
				});
				parentElement.addEventListener("mouseleave", () => {
					theSwiper.disable();
					setTimeout(() => {
						theSwiper.autoplay.stop();
					}, 500);
				});
			} */

			if (slider.classList.contains("pinned")) {
				this.sctrigger = new ScrollTrigger({
					trigger: slider.closest(".pinned-scroll-trigger"),
					start: `top ${document.getElementById("site-header").offsetHeight - 32}px`,
					end: `bottom -125%`,
					pin: true,
					scrub: 2,
					onEnter: () => {
						window.addEventListener("scroll", (e) => {
							this.scrollSlider(theSwiper);
						});
					},
					onLeaveBack: () => {
						window.removeEventListener("scroll", (e) => {
							this.scrollSlider(theSwiper);
						});
					},
				});
			}
		});
	}

	scrollSlider(swiper) {
		swiper.setProgress(this.sctrigger.progress);
	}
}
